import { render, staticRenderFns } from "./ToolbarButton.vue?vue&type=template&id=079a88d9&scoped=true"
import script from "./ToolbarButton.vue?vue&type=script&lang=ts"
export * from "./ToolbarButton.vue?vue&type=script&lang=ts"
import style0 from "./ToolbarButton.vue?vue&type=style&index=0&id=079a88d9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a88d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079a88d9')) {
      api.createRecord('079a88d9', component.options)
    } else {
      api.reload('079a88d9', component.options)
    }
    module.hot.accept("./ToolbarButton.vue?vue&type=template&id=079a88d9&scoped=true", function () {
      api.rerender('079a88d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ToolbarButton.vue"
export default component.exports